export class SCCInput{
    topologyId: string;
    voltageAtRoot: number;
    rootGridElementId: number;
    planningScenarioId?: number;
    coefficientMin: number;
    coefficientMax: number;
}